import script from "./NoBgInput.vue?vue&type=script&setup=true&lang=js"
export * from "./NoBgInput.vue?vue&type=script&setup=true&lang=js"

import "./NoBgInput.vue?vue&type=style&index=0&id=f0b970fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0b970fe"]])

export default __exports__